import { Path } from '@/types/global';
import { NationalRecord } from '@/types/turn-api';

export const path = (path: Path<NationalRecord>) => path;
